import React, { useState } from "react";
import {
  IconGoogle,
  IconNotVerified,
  IconVerified,
} from "../../components/icons";
import { Form, Button, Input } from "antd";
import { unverifyGoogle, verifyGoogle } from "../../api";
import { useTranslation } from "react-i18next";
import { commonUtil } from "../../utils";
import { useGoogleLogin } from "@react-oauth/google";

interface Props {
  reload: Function;
  identifier: any;
  canUnlink: boolean;
}

const UpdateGoogle: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [loading, setLoading] = useState<boolean>(false);

  const handleLoginGoogle = async (response: any) => {
    const res = await verifyGoogle({ accessToken: response.accessToken });
    setLoading(false);
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    commonUtil.showMessage("success", t("notification:Liên kết thành công"));
    props.reload();
  };
  const handleLoginGoogleFailure = async (response: any) => {
    setLoading(false);
    let textError = "";
    switch (response["error"]) {
      case "idpiframe_initialization_failed":
        textError = "initialization of the Google Auth API failed";
        break;
      case "popup_closed_by_user":
        textError =
          "The user closed the popup before finishing the sign in flow";
        break;
      case "access_denied":
        textError = "The user denied the permission to the scopes required";
        break;
      case "immediate_failed":
        textError =
          "No user could be automatically selected without prompting the consent flow";
        break;
    }
    // commonUtil.showMessage('error', t(textError))
  };
  const onClickRemoveGoogle = async () => {
    const res = await unverifyGoogle();
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    commonUtil.showMessage(
      "success",
      t("notification:Hủy liên kết thành công")
    );
    props.reload();
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => handleLoginGoogle(codeResponse),
    onError: handleLoginGoogleFailure,
  });

  return (
    <Form.Item
      label={
        <div className="flex items-center gap-4">
          Google&nbsp;
          {props.identifier && props.identifier.status === "verified" ? (
            <IconVerified />
          ) : (
            <IconNotVerified />
          )}
        </div>
      }
    >
      {props.identifier ? (
        <Input
          disabled={true}
          style={{ backgroundColor: "white", color: "black" }}
          prefix={
            <>
              <IconGoogle width={20} height={20} />
              &nbsp;&nbsp;
              <span>
                {props.identifier.metadata?.displayName || "Đã liên kết Google"}
              </span>
            </>
          }
          suffix={
            props.identifier && props.canUnlink ? (
              <span
                style={{ color: "#F5222D", cursor: "pointer" }}
                onClick={(e) => onClickRemoveGoogle()}
              >
                {t("common:Bỏ kết nối")}
              </span>
            ) : null
          }
        />
      ) : (
        // <GoogleLogin
        //   clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}
        //   render={renderProps => (
        //     <Button loading={loading} size={'large'} block={true} onClick={renderProps.onClick} style={{ paddingLeft: '11px', display: 'flex', alignItems: 'center' }}>
        //       <IconGoogle width={20} height={20} />&nbsp;&nbsp;
        //       <span style={{ color: '#40a9ff' }}>{t('common:Liên kết tài khoản Google')}</span>
        //     </Button>
        //   )}
        //   onRequest={() => { setLoading(true) }}
        //   onSuccess={handleLoginGoogle}
        //   onFailure={handleLoginGoogleFailure}
        //   cookiePolicy={'single_host_origin'}
        // />
        <Button
          block={true}
          onClick={() => login()}
          className="!border-red-primary !px-16 !py-8 h-auto"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconGoogle />
          <span className="text-red-primary">Liên kết tài khoản Google</span>
        </Button>
      )}
    </Form.Item>
  );
};

export default UpdateGoogle;
